import {
  ModalDialog,
  ModalMessage,
  ModalMessageColorsEnum,
  WarningInfoIcon,
} from '@acceso/design-system';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type DetectionFormValues = {
  active_detection: boolean;
};

type DetectionModalProps<T extends DetectionFormValues = DetectionFormValues> = {
  open: boolean;
  onClose: () => void;
  form: UseFormReturn<T>;
};

const DetectionModal = <T extends DetectionFormValues>({
  open,
  onClose,
  form,
}: DetectionModalProps<T>) => {
  const { t } = useTranslation();

  return (
    <ModalDialog
      isOpen={open}
      onClose={onClose}
      onAction={() =>
        form.setValue(
          // @ts-ignore
          'active_detection',
          false
        )
      }
      heading={t('Desactivar detección por imagen')}
      actionLabel={t('Desactivar')}
      linkLabel={t('Cancelar')}
      color={ModalMessageColorsEnum.WARNING}
      parentClassName="z-[300]"
    >
      <ModalMessage
        title={t('¿Estás seguro de querer desactivar la detección por imagen?')}
        description={t(
          'A partir de su desactivación dejará de detectarse en las franjas y cortes. Conservarás la galería para poder reactivar su detección en un futuro'
        )}
        icon={WarningInfoIcon}
      />
    </ModalDialog>
  );
};

export { DetectionModal };
